// removed by extract-text-webpack-plugin
module.exports = {"Header":"_3c4FOT0x","MobileHeaderTitle":"_1y8u1Lr9","MainNav":"_28xn-mKf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/header-component.styles.scss
// module id = 523
// module chunks = 0